module.exports = __webpack_public_path__ + "assets/img/bg-1.5e10caf6.png";